import {FC} from 'react'
import {Link} from 'react-router-dom'
import {text} from 'shared/mirrors/text'
import styles from './styles.module.scss'

export const InfoBlock: FC = () => (
  <>
    By clicking “Pay” button you accept
    <Link className={styles.link} to='/terms-of-use' target='_blank'>
      &nbsp;Payment & Refund Policy</Link>.
    <br /><br />

    {text.main.estoniaAddress} and its
    affiliates operating {text.main.siteName} service.
    <br /><br />

    This site uses 128-bit SSL encryption for the security of the data exchange between your browser
    and
    our servers.
    <br /><br />

    For privacy reasons this payment will be shown on
    your card statement with a neutral Internet
    merchant description (i.e. not {text.main.siteName}).

    <br /><br />

    If you want to cancel auto top-up you should go to my profile settings page and use billing section {' '}
    <Link className={styles.link} to='/settings' target='_blank'>
      here
    </Link>.
  </>
)